module.exports = __webpack_public_path__ + "img/744.43e6bf66.jpg";